import { SelectablePartner, useCollections } from 'pages/partners/pages/collections/context';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Table } from 'react-bootstrap';

type CollectionConfirmStepProps = {
    name: string;
    description: string;
    selectedPartners: SelectablePartner[];
};

export const CollectionConfirmStep = (props: CollectionConfirmStepProps) => {

    const { name, description, selectedPartners } = props;

    const { showAdvancedColumns } = useCollections();

    return (
        <div>
            <h5 className="text-strong mb-3">
                {<FormattedMessage defaultMessage="Confirm Settings" description="Pasos" id="confirm_settings.edb3d2c8" />}
            </h5>

            <div className="card card-body mb-4">
                <div className="d-flex mb-2">
                    <span className="fw-bold me-2">
                        {<FormattedMessage defaultMessage="Association Name" id="association_name.b1c7b49c" />}
                        :
                    </span>
                    <span>
                        {name}
                    </span>
                </div>
                <div className="d-flex">
                    <span className="fw-bold me-2">
                        {<FormattedMessage defaultMessage="Description" description="Formulario" id="description.e1c24171" />}
                        :
                    </span>
                    <span>
                        {description || 'None'}
                    </span>
                </div>
            </div>

            <h6 className="fw-bold">
                {<FormattedMessage defaultMessage="Currently Selected Partners" id="currently_selected_partners.70ec89f2" />}
            </h6>
            <Table bordered hover responsive size="sm">
                <thead>
                    <tr>
                        <th>
                            {<FormattedMessage defaultMessage="Organization" description="New" id="organization.7cb537a9" />}
                        </th>
                        {showAdvancedColumns && (
                        <th>
                            {<FormattedMessage defaultMessage="Sector" description="New" id="sector.343b1273" />}
                        </th>
                        )}
                        {showAdvancedColumns && (
                        <th>
                            {<FormattedMessage defaultMessage="Country" description="New" id="country.05543f81" />}
                        </th>
                        )}
                        <th>
                            {<FormattedMessage defaultMessage="Status" id="status.ad856ad7" />}
                        </th>
                        <th>
                            {<FormattedMessage defaultMessage="Created" id="created.8d9f8791" />}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {selectedPartners.map(partner => (
                        <tr key={partner.ID}>
                            <td>
                                {partner.Name}
                            </td>

                            {showAdvancedColumns && (
                                <td>
                                    {partner.Sector ?? ''}
                                </td>
                            )}

                            {showAdvancedColumns && (
                                <td>
                                    {partner.Country?.Name ?? ''}
                                </td>
                            )}

                            <td>
                                {partner.Active ? <FormattedMessage defaultMessage="Active" id="active.b9616c88" /> : <FormattedMessage defaultMessage="Inactive" id="inactive.5fb6d21a" />}
                            </td>

                            <td>
                                {partner.DateCreate
                                    ? <FormattedDate day="numeric" month="short" value={new Date(partner.DateCreate)} year="numeric" />
                                    : ''
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );

};
